(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["companus-bundle-upgrade"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('companus-bundle-upgrade')){
customElements.define('companus-bundle-upgrade',class extends HTMLElement{
connectedCallback(){
this.shirt=JSON.parse(this.querySelector('[data-shirt]').textContent);
this.info=this.closest('[id^="ProductInfo-"]');
this.sync=()=>{
const options=Array.from(this.info.querySelectorAll('variant-radios fieldset')).map(field=>field.querySelector('input:checked')?.value);
if(!options.length)options.push(...Array.from(this.info.querySelectorAll('variant-selects select')).map(select=>select.value));
const id=this.info.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
const selected=this.shirt.find(v=>options.length&&v.options.every((o,i)=>o===options[i]))||this.shirt.find(v=>String(v.id)===id)||this.shirt[0];
this.querySelectorAll('[data-bundle]').forEach(card=>{
const variants=JSON.parse(card.querySelector('[data-variants]').textContent);
const match=variants.find(v=>v.available&&v.options[0]===this.dataset.design&&v.options[1]===selected.options[0]&&v.options[2]===selected.options[1]);
const link=card.querySelector('[data-upgrade-link]');
link.setAttribute('aria-disabled',match?'false':'true');
card.querySelector('.companus-upgrade__status').textContent=match?selected.options.join(' / '):this.querySelector('[data-unavailable]').textContent;
if(match){const url=new URL(link.href);url.searchParams.set('variant',match.id);link.href=url.toString();}
});
};
this.info.addEventListener('change',this.sync);
this.addEventListener('click',event=>{const link=event.target.closest('[data-upgrade-link]');if(link){this.sync();if(link.getAttribute('aria-disabled')==='true')event.preventDefault();}});
this.sync();
}
disconnectedCallback(){this.info?.removeEventListener('change',this.sync);}
});
}
  } catch(e) { console.error(e); }
})();

})();
